import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["text", "collapseHeight"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box, Collapse, Link, Typography } from '@mui/material';
import { useRef, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ShowMoreText = function ShowMoreText(_ref) {
  var _collapseTextRef$curr;

  var text = _ref.text,
      _ref$collapseHeight = _ref.collapseHeight,
      collapseHeight = _ref$collapseHeight === void 0 ? 216 : _ref$collapseHeight,
      typographyProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      showMore = _useState[0],
      setShowMore = _useState[1];

  var collapseTextRef = useRef(null);
  return (_collapseTextRef$curr = collapseTextRef.current) !== null && _collapseTextRef$curr !== void 0 && _collapseTextRef$curr.offsetHeight && collapseTextRef.current.offsetHeight >= collapseHeight ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Box, {
      sx: !showMore ? {
        maskImage: 'linear-gradient(to bottom, black 77%, transparent 100%)',
        width: 1,
        height: collapseHeight - 4
      } : undefined,
      children: /*#__PURE__*/_jsx(Collapse, {
        "in": showMore,
        collapsedSize: collapseHeight,
        timeout: "auto",
        children: /*#__PURE__*/_jsx(Typography, _objectSpread({
          ref: collapseTextRef,
          component: "span",
          dangerouslySetInnerHTML: {
            __html: text
          }
        }, typographyProps))
      })
    }), !showMore && /*#__PURE__*/_jsx(Link, {
      sx: {
        display: 'block',
        cursor: 'pointer',
        width: 'fit-content'
      },
      onClick: function onClick() {
        return setShowMore(!showMore);
      },
      children: "Show more"
    })]
  }) : /*#__PURE__*/_jsx(Typography, _objectSpread({
    ref: collapseTextRef,
    component: "span",
    dangerouslySetInnerHTML: {
      __html: text
    }
  }, typographyProps));
};